if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('span');

        this.loadingSpinner =
          this.querySelector('.loading__spinner');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');
        this.loadingSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        const formData = new FormData(this.form);
        const bundleItems =
          this.getBundleItems(formData);

        const productVariantId =
          bundleItems?.[0]?.id ||
          formData.get('id');

        let sectionIds = [];

        if (this.cart) {
          sectionIds = this.cart
            .getSectionsToRender()
            .map((section) => section.id);

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        if (bundleItems) {
          config.headers['Content-Type'] =
            'application/json';

          const requestBody = {
            items: bundleItems,
          };

          if (this.cart) {
            requestBody.sections = sectionIds;
            requestBody.sections_url =
              window.location.pathname;
          }

          config.body = JSON.stringify(requestBody);
        } else {
          delete config.headers['Content-Type'];

          formData.delete(
            'bundle_variant_ids[]'
          );

          if (this.cart) {
            formData.append(
              'sections',
              sectionIds
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );
          }

          config.body = formData;
        }

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId,
                  errors:
                    response.errors ||
                    response.description,
                  message: response.message,
                }
              );

              this.handleErrorMessage(
                response.description ||
                  response.message
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                this.error = true;
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location =
                window.routes.cart_url;
              return;
            }

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId,
                  cartData: response,
                }
              ).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(
                          response
                        );
                      }
                    );
                  });
                },
                {
                  once: true,
                }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(
                    response
                  );
                }
              );
            }
          })
          .catch((error) => {
            console.error(error);

            this.handleErrorMessage(
              window.variantStrings
                ?.unavailable ||
                'Unable to add these items to your cart.'
            );

            this.error = false;
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            this.loadingSpinner?.classList.add(
              'hidden'
            );

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      getBundleItems(formData) {
        const formId = this.form.id;

        if (!formId) return null;

        const escapedFormId =
          window.CSS?.escape
            ? window.CSS.escape(formId)
            : formId.replace(
                /(["\\])/g,
                '\\$1'
              );

        let variantIds = formData
          .getAll('bundle_variant_ids[]')
          .map((id) =>
            String(id).trim()
          )
          .filter(Boolean);

        if (!variantIds.length) {
          const bundleSelects =
            document.querySelectorAll(
              `[data-bundle-variant-select][form="${escapedFormId}"]:not(:disabled)`
            );

          variantIds = Array.from(
            bundleSelects
          )
            .map((select) =>
              String(
                select.selectedOptions[0]
                  ?.value || ''
              ).trim()
            )
            .filter(Boolean);
        }

        if (!variantIds.length) {
          return null;
        }

        const expectedQuantity = Number(
          formData.get('quantity')
        );

        if (
          !expectedQuantity ||
          variantIds.length !==
            expectedQuantity
        ) {
          return null;
        }

        const properties = {};
        let sellingPlan;

        for (
          const [key, value]
          of formData.entries()
        ) {
          if (
            key === 'selling_plan' &&
            typeof value === 'string' &&
            value
          ) {
            sellingPlan = value;
          }

          if (
            key.startsWith(
              'properties['
            ) &&
            typeof value === 'string' &&
            value
          ) {
            const propertyName =
              key.slice(11, -1);

            if (propertyName) {
              properties[propertyName] =
                value;
            }
          }
        }

        const groupedItems = new Map();

        variantIds.forEach(
          (variantId) => {
            const id =
              String(variantId).trim();

            if (!id) return;

            const existingItem =
              groupedItems.get(id);

            if (existingItem) {
              existingItem.quantity += 1;
              return;
            }

            const item = {
              id,
              quantity: 1,
            };

            if (
              Object.keys(properties).length
            ) {
              item.properties = {
                ...properties,
              };
            }

            if (sellingPlan) {
              item.selling_plan =
                sellingPlan;
            }

            groupedItems.set(id, item);
          }
        );

        const items = Array.from(
          groupedItems.values()
        );

        const totalQuantity =
          items.reduce(
            (total, item) =>
              total + item.quantity,
            0
          );

        if (
          totalQuantity !==
          expectedQuantity
        ) {
          return null;
        }

        return items;
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}